var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isReady,
          expression: "isReady",
        },
      ],
      staticClass: "table-filter-wrapper",
    },
    [
      _c(
        "filter-dialog",
        {
          ref: "filter-dialog",
          on: {
            "show-save-dialog": _vm.showSaveFilterDialog,
            "show-delete-dialog": _vm.showDeleteFilterDialog,
          },
        },
        [
          _c("inquiry-filter", {
            attrs: { properties: _vm.filterProperties, "is-dialog": true },
            on: { input: _vm.refresh },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("table-component", {
        ref: "table-component",
        attrs: {
          "data-page": "application-list",
          delegate: _vm.delegate,
          title: _vm.t("app-inquiries"),
          "has-filter": true,
          export: "true",
        },
        on: {
          "row-clicked": _vm.rowClicked,
          ready: function ($event) {
            _vm.isReady = true
          },
          "show-filter": function ($event) {
            _vm.$refs["filter-dialog"].show = true
          },
        },
      }),
      _vm._v(" "),
      _c("inquiry-filter", {
        ref: "filter-panel",
        attrs: { properties: _vm.filterProperties },
        on: {
          save: _vm.saveFilter,
          delete: function ($event) {
            return _vm.deleteFilter($event)
          },
          input: _vm.refresh,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }